import * as React from "react";

const RestrictionIcon: React.FC = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
                stroke="#0E0E0E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line x1="3.61458" y1="2.48785" x2="14.2544" y2="15.2557" stroke="#0E0E0E" strokeWidth="1.6" />
        </svg>
    );
};

export default React.memo(RestrictionIcon);
